// Tipos para Evolução Clínica (SOAP)

export enum NoteType {
  SOAP = 'SOAP',
  ADDENDUM = 'ADDENDUM',
  PRESCRIPTION = 'PRESCRIPTION',
  REFERRAL = 'REFERRAL',
  CERTIFICATE = 'CERTIFICATE',
  REPORT = 'REPORT'
}

export enum NoteStatus {
  DRAFT = 'DRAFT',
  SIGNED = 'SIGNED',
  AMENDED = 'AMENDED',
  CANCELLED = 'CANCELLED'
}

export enum EncounterType {
  CONSULTATION = 'CONSULTATION',
  FOLLOW_UP = 'FOLLOW_UP',
  URGENT = 'URGENT',
  TELEHEALTH = 'TELEHEALTH',
  HOME_VISIT = 'HOME_VISIT'
}

export enum EncounterStatus {
  SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW'
}

export interface VitalSigns {
  systolicBP?: number;
  diastolicBP?: number;
  heartRate?: number;
  respiratoryRate?: number;
  temperature?: number;
  oxygenSaturation?: number;
  weight?: number;
  height?: number;
  painLevel?: number;
  measuredAt?: string;
  // Campos calculados
  bmi?: number;
  formattedBloodPressure?: string;
}

export interface ClinicalNoteResponse {
  id: string;
  patientId: string;
  patientName: string;
  encounterId?: string;
  type: NoteType;
  typeLabel?: string;
  subjective?: string;
  objective?: string;
  assessment?: string;
  plan?: string;
  vitalSigns?: VitalSigns;
  problemsAddressed: PatientProblemSimple[];
  status: NoteStatus;
  statusLabel?: string;
  editable?: boolean;
  signedAt?: string;
  signedById?: string;
  signedByName?: string;
  cancelledAt?: string;
  cancelledById?: string;
  cancelledByName?: string;
  cancellationReason?: string;
  createdById?: string;
  createdByName: string;
  createdAt: string;
  updatedAt: string;
}

export interface ClinicalNoteListResponse {
  id: string;
  patientId: string;
  patientName: string;
  type: NoteType;
  typeLabel?: string;
  status: NoteStatus;
  statusLabel?: string;
  subjectiveSummary?: string;
  assessmentSummary?: string;
  summary?: string;
  createdByName: string;
  createdAt: string;
}

export interface PatientProblemSimple {
  id: string;
  cidCode?: string;
  description: string;
}

export interface CreateClinicalNoteRequest {
  patientId: string;
  encounterId?: string;
  type?: NoteType;
  subjective?: string;
  objective?: string;
  assessment?: string;
  plan?: string;
  vitalSigns?: VitalSigns;
  problemIds?: string[];
  signImmediately?: boolean;
}

export interface UpdateClinicalNoteRequest {
  subjective?: string;
  objective?: string;
  assessment?: string;
  plan?: string;
  vitalSigns?: VitalSigns;
  problemIds?: string[];
}

export interface EncounterResponse {
  id: string;
  patientId: string;
  patientName: string;
  scheduledAt?: string;
  startedAt?: string;
  endedAt?: string;
  type: EncounterType;
  typeLabel?: string;
  status: EncounterStatus;
  statusLabel?: string;
  providerId?: string;
  providerName?: string;
  reason?: string;
  notes: ClinicalNoteListResponse[];
  createdAt: string;
  updatedAt: string;
}

export interface EncounterListResponse {
  id: string;
  patientId: string;
  patientName: string;
  scheduledAt?: string;
  startedAt?: string;
  endedAt?: string;
  type: EncounterType;
  typeLabel?: string;
  status: EncounterStatus;
  statusLabel?: string;
  providerName?: string;
  reason?: string;
  notesCount: number;
  createdAt: string;
}

export interface CreateEncounterRequest {
  patientId: string;
  scheduledAt?: string;
  type: EncounterType;
  reason?: string;
}

// Labels para exibição
export const NoteTypeLabels: Record<NoteType, string> = {
  [NoteType.SOAP]: 'Evolução SOAP',
  [NoteType.ADDENDUM]: 'Adendo',
  [NoteType.PRESCRIPTION]: 'Prescrição',
  [NoteType.REFERRAL]: 'Encaminhamento',
  [NoteType.CERTIFICATE]: 'Atestado',
  [NoteType.REPORT]: 'Laudo'
};

export const NoteStatusLabels: Record<NoteStatus, string> = {
  [NoteStatus.DRAFT]: 'Rascunho',
  [NoteStatus.SIGNED]: 'Assinada',
  [NoteStatus.AMENDED]: 'Alterada',
  [NoteStatus.CANCELLED]: 'Cancelada'
};

export const EncounterTypeLabels: Record<EncounterType, string> = {
  [EncounterType.CONSULTATION]: 'Consulta',
  [EncounterType.FOLLOW_UP]: 'Retorno',
  [EncounterType.URGENT]: 'Urgência',
  [EncounterType.TELEHEALTH]: 'Teleconsulta',
  [EncounterType.HOME_VISIT]: 'Visita Domiciliar'
};

export const EncounterStatusLabels: Record<EncounterStatus, string> = {
  [EncounterStatus.SCHEDULED]: 'Agendado',
  [EncounterStatus.IN_PROGRESS]: 'Em Atendimento',
  [EncounterStatus.COMPLETED]: 'Concluído',
  [EncounterStatus.CANCELLED]: 'Cancelado',
  [EncounterStatus.NO_SHOW]: 'Não Compareceu'
};
